import { render, staticRenderFns } from "./IdProof.vue?vue&type=template&id=0c219669"
import script from "./IdProof.vue?vue&type=script&lang=js"
export * from "./IdProof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports